import { OnInit } from '@angular/core';
var SpinnerWithOverlay = /** @class */ (function () {
    function SpinnerWithOverlay() {
        this.showOnlyOverlay = false;
    }
    SpinnerWithOverlay.prototype.ngOnInit = function () {
        if (this.showSpinner) {
            this.showOnlyOverlay = true;
        }
        else {
            this.showOnlyOverlay = false;
        }
    };
    SpinnerWithOverlay.prototype.ngOnChanges = function () {
        if (this.showSpinner) {
            this.showOnlyOverlay = true;
        }
        else {
            this.showOnlyOverlay = false;
        }
    };
    SpinnerWithOverlay.prototype.overlayShowHide = function () {
        if (this.showOnlyOverlay === true) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SpinnerWithOverlay.prototype.spinnerShowHide = function () {
        if (this.showSpinner === true) {
            return "block";
        }
        else {
            return "none";
        }
    };
    return SpinnerWithOverlay;
}());
export { SpinnerWithOverlay };
//# sourceMappingURL=spinnerwithoverlay.component.js.map